export default "__VITE_ASSET__C9CuHC1w__"